define('app/views/yadisa_checkout_shipping_view',['app/setup','jquery.cookie'], function(takhfifan, jq_cookie) {

  takhfifan.YadisaCheckoutShipping = Backbone.View.extend({

    events: {
     'click #yadisaCOAddresses .dropdown-items li': 'informUpdateAddress',
     'click #yadisaCoEditAddress': 'informEditAddress',
     'click #yadisaCoAddAddress': 'informAddingAddress'
    },

    initialize: function (options) {
      var _this = this;
      this.$addressess = this.$el.find("#yadisaCOAddresses");
      this.$editBtn = this.$el.find("#yadisaCoEditAddress");
      this.$addBtn = this.$el.find("#yadisaCoAddAddress");
      this.addressTemplate = _.template("<%= firstName %> <%= lastName %> (<%= city %> - <%= street %>)");

      // init addresses
      this.$addressListItems = {};
      $('.tkh-shipping-address').each(function(){
        var $addLI = $("<li />"),
            addressId = $(this).data('addressId');
        $addLI.data('id', addressId);
        $addLI.text(_this.addressTemplate({
            firstName:$(this).data('firstname'),
            lastName : $(this).data('lastname'),
            city: $(this).data('city'),
            street : $(this).data('street')
        }));
        _this.$addressess.find('.dropdown-items ul').append($addLI);
        _this.$addressListItems[addressId] = $addLI;
      });

      takhfifan.eventHub.on('shipping:addressesActivated', function(addressId) {
        if(!_.isUndefined(_this.$addressListItems[addressId])){
          _this.updateDropDownAddress(addressId);
        }
      });

      takhfifan.eventHub.on('shipping:addressSaved', function(addressId) {
        _this.editAddressItem(addressId);
      });

      var $activeAddress = this.$el.find('.tkh-shipping-address.active');
      if($activeAddress.length){
        _this.$editBtn.removeClass('hide');
        this.updateDropDownAddress($activeAddress.data('addressId'));
      }
    },

    informUpdateAddress: function (e) {
      var addId = $(e.target).data("id");
      takhfifan.eventHub.trigger('yadisaCO:changeAddress', addId);
    },
    
    updateDropDownAddress: function (addressId) {
      var $thisLi = this.$addressListItems[addressId];
      this.$editBtn.data('addressId', addressId);

      //copy from main dropdown object
      var $dropdownItemsParent = this.$el.find('#yadisaCOAddresses .dropdown');
      $dropdownItemsParent.find('.dropdown-items li.active').removeClass("active");
      $thisLi.addClass("active");
      $dropdownItemsParent.find(".default-text [class*='value']").text($(".active", $dropdownItemsParent).text());
      $dropdownItemsParent.removeClass("dropdown-visible");
      $(".item-arrow").removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
      var target = $('#' + $thisLi.data('target'));
      target.val($(".active", $dropdownItemsParent).text());
    },

    informEditAddress: function (e) {
      var addId = $(e.target).data("addressId");
      takhfifan.eventHub.trigger('yadisaCO:editAddress', addId);
    },

    editAddressItem: function (addressModel) {
      var addressId = addressModel.shipping_address_id,
          $thisLi = this.$addressListItems[addressId],
          _this = this,
          addressLine = _this.addressTemplate({
            firstName:addressModel['shipping[firstname]'],
            lastName : addressModel['shipping[lastname]'],
            city: addressModel['shipping[city]'] ,
            street : addressModel['shipping[street][]']
          });

      if(_.isUndefined($thisLi)){
        //this is a new item
        $thisLi = $("<li />");
        $thisLi.data('id', addressId);
        $thisLi.text(addressLine);
        this.$addressess.find('.dropdown-items ul').append($thisLi);
        this.$addressListItems[addressId] = $thisLi;
      } else {
        $thisLi.text(addressLine);
      }
      this.updateDropDownAddress(addressId);
    },

    informAddingAddress: function(e){
      takhfifan.eventHub.trigger('yadisaCO:addingAddress');
    }
  })
});
